import request from '@/util/request2';

//分页查询
export async function listSysLogApi(params) {
    // return await doGet('/api/auth/sysLog/pager', params);
    return request({
        url: '/api/auth/sysLog/pager',
        method: 'post',
        data: params
    });
}

/**
 * 发送前端日志的方法
 * @param json
 * @return {Promise<Response>}
 */
export const frontLogApi = (json) => {
    return window.fetch('/api/frontLog/save', {
        method: 'POST',
        body: JSON.stringify(json),
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    });
};